<template>
  <b-container class="mw-100 mt-3">
    <b-card class="mt-4 mb-4">
      <standard-table ref="userTable"
                      search-id="user-search"
                      :items="items"
                      :fields="fields"
                      :search-place-holder="`${$tc('message.example', 1)}: admin_123`"

                      :row-before-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 1,orderMd: 1,orderLg: 3,orderXl: 3}"
                      :row-search="{cols: 12,sm: 12,md: 12,lg: 4,xl: 4,order: 1,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"
                      :row-after-search="{cols: 12, sm: 12, md: 12, lg: 4, xl: 4, order: 2, orderSm: 3, orderMd: 3, orderLg: 2, orderXl: 2}"

                      :after-search="{cols: 12, sm: 12, md: 12, lg: 12, xl: 12}"

                      :row-pagination="{cols: 12, sm: 12, md: 6, lg: 5, xl: 5}"
                      :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 4}"
                      :row-per-page="{cols: 12, sm: 12, md: 5, lg: 3, xl: 2}"
                      :row-after-per-page="{cols: 12, sm: 12, md: 12, lg: 3, xl: 1}"

                      fullWidth="true"
                      noContainerPadding="true"
                      @rowEdit="pushToEdit($event.item)"
                      @rowDelete="checkBeforeDelete($event.item)">

        <b-container slot="row-before-search" class="mw-100 p-0">
          <b-row align-h="end">
            <b-col cols="auto">
              <!-- config[crud], create - read - update - delete -->
              <b-button v-on:click="pushToEdit()" class="b-c-blue mb-3" id="add-user" v-if="config.c">
                {{$t('message.add')}}
              </b-button>
            </b-col>
          </b-row>
        </b-container>

        <b-container slot="row-after-search" class="mw-100 p-0 ">
          <b-row>
            <b-col cols="auto">
              <b-button v-on:click="resetFilters()" class="b-c-green" id="reset-filters">
                {{$t('message.resetFilters')}}
              </b-button>
            </b-col>

            <b-col cols="auto" class="mb-3">
              <b-button @click="showCollapse = !showCollapse" :class="showCollapse ? 'b-c-red' : 'b-c-green'">
                <span v-show="!showCollapse" class="when-opened">
                  {{$t('message.show')}} {{$tc('message.filter', 2).toLowerCase()}}
                </span>
                <span v-show="showCollapse" class="when-closed">
                  {{$t('message.hide')}} {{$tc('message.filter', 2).toLowerCase()}}
                </span>
              </b-button>
            </b-col>
          </b-row>
        </b-container>

        <b-container slot="after-search" class="mw-100 p-0">
          <b-collapse id="my-collapse" v-model="showCollapse">
            <b-container class="mw-100 m-0 p-0">
              <b-row>
                <b-col cols="12" sm="12" md="6" lg="4" xl="3">
                  <b-form-group :label="`${$tc('message.role', 1)}`"
                                label-for="input-vehicle">
                    <model-list-select id="input-vehicle"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="roleOptions && roleOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="roleFilter"
                                       :list="roleOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="6" lg="4" xl="3">
                  <b-form-group :label="`${$tc('message.status', 1)}`"
                                label-for="input-status">
                    <model-list-select id="input-status"
                                       option-text="text"
                                       option-value="value"
                                       :placeholder="statusOptions && statusOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                       v-model="statusFilter"
                                       :list="statusOptions">
                    </model-list-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </b-collapse>
        </b-container>

        <b-container slot="row-after-per-page" class="mw-100 p-0">
          <b-row>
            <b-col>
              <b-button class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0"
                        id="excel-button" @click="$refs.userTable.excel($tc('message.user', 2))"> Excel
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </standard-table>
    </b-card>

    <b-modal ref="checkDisableModal" id="checkDisableModal" :title="`${$t('message.caution')}!`">
      <b-container>
        <h5>{{$t('info.disableUserCheck')}} {{disableItem.userName}}?</h5>
      </b-container>

      <div slot="modal-footer" class="w-100 justify-content-end d-flex">
        <b-button id="nw-delete-close" class="m-1 b-c-green" @click="hideCheckDisableModal()">{{$t('message.cancel')}}</b-button>

        <b-button id="nw-delete-continue" class="m-1 b-c-green" @click="saveUser(disableItem, exitOnConfirm)">{{$t('message.continue')}}</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import Vue from 'vue'
import { cloneDeep, filter, find, sortBy, capitalize } from 'lodash'

export default {
  name: 'User',
  created () {
    this.fetchData()
  },
  mounted () {
    this.$root.$on('change-lang', () => {
      if (this.$el.isConnected) {
        this.resetFilters()
        this.updateStaticOptions()
        this.updateDynamicOptions()
      }
    })
  },
  watch: {
    roleFilter (val) {
      this.updateDynamicOptions()

      let items = cloneDeep(this.items)
      const foundedRole = find(this.roleOptions, obj => obj.value === val)

      if (val !== '' && (!!val || val === 0)) items = filter(items, obj => obj.parsedRole === foundedRole.text)
      items = this.filterByStatus(items, this.statusFilter)

      this.items = items
    },
    statusFilter (val) {
      this.updateDynamicOptions()

      const roleFilter = this.roleFilter
      const foundedRole = find(this.roleOptions, obj => obj.value === roleFilter)
      let items = cloneDeep(this.items)

      if (roleFilter !== '' && (!!roleFilter || roleFilter === 0)) items = filter(items, obj => obj.parsedRole === foundedRole.text)
      items = this.filterByStatus(items, val)

      this.items = items
    }
  },
  data () {
    const session = Vue.getLocalStorage('session')
    const user = session.user
    const config = this.$route.meta.config

    return {
      config,
      currentUser: user.userName,
      currentRole: user.config.role,
      isDefaultAdmin: user.config && user.config.adminDefault && user.config.adminDefault === 'true',
      originalItems: [],
      items: [],
      fields: [],
      roleOptions: [],
      statusOptions: [],
      roleFilter: '',
      statusFilter: 'false',
      showCollapse: false,
      disableItem: {},
      exitOnConfirm: false,
      infoItem: {}
    }
  },
  methods: {
    // main functions
    fetchData () {
      this.$root.$emit('activeLoader', true)
      this.updateStaticOptions()
      this.getUsers().then(() => {
        this.updateDynamicOptions()
        this.items = this.filterByStatus(this.items, 'false')
        this.$root.$emit('activeLoader', false)
      })
    },
    updateStaticOptions () {
      this.getUserFields()
      this.getRoleOptions()
      this.getStatusOptions()
    },
    updateDynamicOptions () {
      const editedItems = []
      cloneDeep(this.originalItems).forEach(user => {
        const editedUser = user

        if (user.config.role === 'Admin' && user.config && user.config.adminDefault && user.config.adminDefault === 'true') {
          editedUser.parsedRole = this.$tc('message.adminDefault', 1)
        } else {
          if (user.config.role) editedUser.parsedRole = this.$tc(`message.${user.config.role.toLowerCase()}`, 1)
        }

        editedUser.status = user.config
          ? (user.config.disabled === 'true' ? this.$tc('message.disabled', 0) : this.$tc('message.enabled', 0))
          : this.$tc('message.enabled', 0)
        editedItems.push(editedUser)
      })
      this.items = editedItems
    },
    getUserFields () {
      this.fields = [
        // config[crud], create - read - update - delete
        { key: 'edit', label: '', hideInTable: !this.config.u && !this.config.r },
        { key: 'delete', label: '', hideInTable: !this.config.d },
        { key: 'fullName', label: this.$tc('message.name', 1), sortable: true, sortDirection: 'desc' },
        { key: 'userName', label: this.$tc('message.user', 1), sortable: true, sortDirection: 'desc' },
        { key: 'parsedRole', label: this.$tc('message.role', 1), sortable: true, sortDirection: 'desc' },
        { key: 'email', label: this.$tc('message.email', 1), sortable: true, sortDirection: 'desc' },
        { key: 'status', label: this.$tc('message.status', 1), sortable: true, sortDirection: 'desc' }
      ]
    },
    getRoleOptions () {
      this.roleOptions = [
        { value: '', text: this.$tc('message.all', 1) },
        { value: 0, text: this.$tc('message.adminDefault', 1) },
        { value: 1, text: this.$tc('message.admin', 1) },
        { value: 2, text: this.$tc('message.operator', 1) }
      ]
    },
    getStatusOptions () {
      this.statusOptions = [
        { value: '', text: this.$tc('message.all', 1) },
        { value: 'false', text: this.$tc('message.enabled', 0) },
        { value: 'true', text: this.$tc('message.disabled', 0) }
      ]
    },
    getUsers () {
      return Vue.myGet(this, '/users', 'users').then((users) => {
        this.originalItems = sortBy(filter(users, obj => obj.userName), o => capitalize(o.userName))
        return users
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    filterByStatus (items, val) {
      return filter(items, obj => {
        if (val === 'true') {
          return obj.config && obj.config.disabled && obj.config.disabled === 'true'
        } else if (val === 'false') {
          return !obj.config || obj.config.disabled === 'false' || obj.config.disabled === 'undefined' || !obj.config.disabled
        }
        return obj
      })
    },
    // table functions
    pushToEdit (item) {
      if (!item) {
        this.$router.push({ name: 'EditUser', params: { id: 'new' } })
      } else {
        const user = this.currentUser
        const role = this.currentRole
        const isDefaultAdmin = this.isDefaultAdmin
        const id = item.userName

        if ((role === 'Admin' && isDefaultAdmin) || user === id || (role === 'Admin' && item.config.adminDefault !== 'true')) {
          this.$router.push({ name: 'EditUser', params: { id } })
        } else {
          Vue.warning(this, this.$tc('warnings.accessDenied', 1))
        }
      }
    },
    checkDefaultAdmins () {
      return Vue.myGet(this, '/users', 'users').then(users => {
        return !!find(users, obj => obj && obj.config && obj.config.adminDefault && obj.config.adminDefault === 'true' && obj.userName !== this.currentUser)
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        return false
      })
    },
    checkBeforeDelete (item) {
      const user = this.currentUser
      const role = this.currentRole
      const id = item.userName

      if (role === 'Admin') {
        if (this.isDefaultAdmin) {
          if (item.config.role === 'Admin' && item.config.adminDefault === 'true') {
            this.checkDefaultAdmins().then(goAhead => {
              if (goAhead) this.showCheckDisableModal(item)
              else Vue.warning(this, this.$tc('warnings.atLeastDefaultAdminNeeded', 1))
            })
          } else {
            this.showCheckDisableModal(item)
          }
        } else if (item.config.adminDefault !== 'true') {
          this.showCheckDisableModal(item)
        }
      } else {
        if (user === id) this.showCheckDisableModal(item)
        else Vue.warning(this, this.$tc('warnings.operatorCanModifyOnlyOperators', 1))
      }
    },
    showCheckDisableModal (item, logout) {
      this.disableItem = item
      this.exitOnConfirm = logout
      this.$refs.checkDisableModal.show()
    },
    hideCheckDisableModal () {
      this.$refs.checkDisableModal.hide()
    },
    saveUser (item, exit) {
      item.config = { disabled: 'true' }
      const id = item.userName

      return Vue.putOrPost(this, true, `/users/${id}`, item).then(() => {
        Vue.success(this, `${this.$tc('message.user', 1)} ${this.$t('success.putSuccess')}`)
        if (exit) this.$router.push({ name: 'Logout' })
        else this.fetchData()
        this.hideCheckDisableModal()
        return true
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        this.hideCheckDisableModal()
        return error
      })
    },
    resetFilters () {
      this.roleFilter = ''
      this.statusFilter = ''
      this.$refs.userTable.resetSearch()
    }
  }
}
</script>
